import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { MenuItems } from '../../enums/MenuItems'
import {
    faBriefcase,
    faDatabase,
    faFileImport,
    faHexagonNodes,
    faSearch,
    faUsers,
} from '@fortawesome/free-solid-svg-icons'
import { AuthHelper } from '../../auth/AuthHelper'
import { UserRoles } from '../../api/tenant/models/UserDto'
import { useSafeUserData } from '../../stateStores/User'
import SidebarItem from '../SidebarItem'
import { Pages } from '../../Pages'
import UserMenu from '../UserMenu'

type Props = {
    activeMenuItem: MenuItems
}

export default function TopBanner({
    activeMenuItem,
}: Props): React.JSX.Element {
    const { user } = useSafeUserData()

    return (
        <header className="sticky top-0 z-50 flex items-center justify-between px-4 py-2 border-b border-gray-200 bg-white">
            {/* Top Banner / Header */}
            {/* Left Item: Logo */}
            <div className="flex-shrink-0">
                <div id="logo" className="flex items-center m-1 mr-14">
                    <div>
                        <FontAwesomeIcon
                            icon={faHexagonNodes}
                            className="text-white bg-ctxt-blue text-lg mr-1 p-2 rounded-lg"
                        />
                    </div>
                    <div className="text-3xl text-gray-800 font-open-sans-soft">
                        Cont<span className="text-blue-600">x</span>t
                    </div>
                </div>
            </div>
            {/* Center Item: Menu System (left aligned) */}
            <nav className="flex-grow ml-4">
                <ul className="flex gap-4">
                    {AuthHelper.userHasSomeRoles(user, [
                        UserRoles.HM,
                        UserRoles.TA,
                    ]) && (
                        <SidebarItem
                            to={Pages.Roles}
                            icon={faBriefcase}
                            label="Roles"
                            active={activeMenuItem === MenuItems.Roles}
                        />
                    )}
                    {AuthHelper.userHasRole(user, UserRoles.ADMIN) && (
                        <SidebarItem
                            to={Pages.Tenants}
                            icon={faUsers}
                            label="Tenants"
                            active={activeMenuItem === MenuItems.Tenants}
                        />
                    )}
                    {AuthHelper.userHasRole(user, UserRoles.ADMIN) && (
                        <SidebarItem
                            to={Pages.ImportLinkedHelperCsv}
                            icon={faFileImport}
                            label="Import CSV"
                            active={activeMenuItem === MenuItems.ImportCSV}
                        />
                    )}
                    {AuthHelper.userHasRole(user, UserRoles.ADMIN) && (
                        <SidebarItem
                            to={Pages.DataManagement}
                            icon={faDatabase}
                            label="Manage Data"
                            active={activeMenuItem === MenuItems.DataManagement}
                        />
                    )}
                    {/* {AuthHelper.userHasRole(user, UserRoles.ADMIN) && (
                        <SidebarItem
                            to={Pages.CandidateSearchVectorTests}
                            icon={faAddressCard}
                            label="Candidate Search"
                            active={
                                activeMenuItem ===
                                MenuItems.CandidateSearchVectorTests
                            }
                        />
                    )} */}
                    {AuthHelper.userHasRole(user, UserRoles.ADMIN) && (
                        <SidebarItem
                            to={Pages.HelixSearch}
                            icon={faSearch}
                            label="Search"
                            active={activeMenuItem === MenuItems.HelixSearch}
                        />
                    )}
                </ul>
            </nav>
            {/* Right Item: Logged In User Dropdown */}
            <div className="flex-shrink-0 relative">
                <UserMenu />
            </div>
        </header>
    )
}
